import React, { useEffect, useState } from "react"
import EmailTemplatePreview from "./EmailTemplatePreview"
import { Button, message } from "antd"

import search from "../../assets/icons/search-normal-gray.svg";
import AddEmailTemplateModal from "./AddEmailTemplate";
import EditEmailTemplateModal from "./EditEmailTemplateModal";
import { controller } from "./controller";
import { isNotEmpty } from "../../utils";
import { testEmailTemplates } from "./testData";


const EmailSmsTemplates = ({selectedTemplate, setSelectedTemplate, isSms}) => {
  const [showEditTemplate, setShowEditTemplate] = useState(false); // For showing edit template modal
  const [showAddEmailTemplate, setShowAddEmailTemplate] = useState(false); // For showing edit template modal
  const [selectedTemplateToEdit, setSelectedTemplateToEdit] = useState(undefined);
  const [emailTemplates, setEmailTemplates] = useState(undefined);
  const [loading, setLoading] = useState(false)

  const fetchEmailTemplates = async () => {
    try {
      setLoading(true)
      const response = await controller.getEmailTemplates(isSms)
      if (!Array.isArray(response.json.results) || !isNotEmpty(response.json.results)) setEmailTemplates(testEmailTemplates)
      else setEmailTemplates(response.json.results)
    } catch (err) {
      message.error("Error occurred while getting templates")
      console.error("Getting Sms or Email templates", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchEmailTemplates();
  }, [])


  return(
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 20, marginBottom: 25 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <p style={{ marginBottom: 0, fontSize: 18 }}>Template</p>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
            <Button style={{ fontSize: 14 }}>
              <img src={search} alt="search" />
              <span style={{ color: "#979797" }}>Search Template</span>
            </Button>

            <Button style={{ fontSize: 14, border: "1px solid #6B43B5" }} type="primary" onClick={() => setShowAddEmailTemplate(true)}>
              Add Template
            </Button>
          </div>
        </div>

        {/* Template container */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 15 }}>
          {isNotEmpty(emailTemplates) && emailTemplates.map((emailTemplate) => (
            <EmailTemplatePreview
              key={emailTemplate.id}
              emailTemplate={emailTemplate}
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
              setShowEditTemplate={setShowEditTemplate}
              setSelectedTemplateToEdit={setSelectedTemplateToEdit}
              isSms={isSms}
            />
          ))}
        </div>
      </div>
          {/* Prevent from processing modal when no template is selected yet */}
      {selectedTemplateToEdit && (
        <EditEmailTemplateModal
          selectedTemplateToEdit={selectedTemplateToEdit}
          setShowEditTemplate={setShowEditTemplate}
          showEditTemplate={showEditTemplate}
          isSms={isSms}
        />
      )}
      <AddEmailTemplateModal setShowAddEmailTemplate={setShowAddEmailTemplate} showAddEmailTemplate={showAddEmailTemplate} isSms={isSms}/>
    </>
  )
}

export default EmailSmsTemplates;